import {
  compose,
  withHandlers,
} from 'recompose';
import { connect } from 'react-redux';
import MobileAppLinkRedirect from '../components/MobileAppLinkRedirect';
import { sendReminderSMSLinkClickedEvent } from '../actions';
import { getFlag } from '../../../flags';

const MobileAppLinkRedirectContainer = compose(
  connect(
    () => ({
      sendReminderSMSLinkClickedEvent,
    }),
  ),
  withHandlers({
    sendTrackingEvent: props =>
      async (customerId, brandId, redirectLink, userAgent) => {
        const flag = 'rebooking-reminder-sms';
        const context = { kind: 'brand', key: brandId, anonymous: false };
        const shouldTrack = await getFlag(flag, brandId && context);
        if (shouldTrack) {
          return props.sendReminderSMSLinkClickedEvent(customerId, brandId, redirectLink, userAgent);
        }

        return Promise.resolve();
      },
  }),
);

export default MobileAppLinkRedirectContainer(MobileAppLinkRedirect);



// WEBPACK FOOTER //
// ./src/app/mobileApp/containers/MobileAppLinkRedirect.js